import { updateDeploymentService } from "../../../../services/deploymentServices";
import buildDeploymentBody from "../build-deployment-body";

export const handleSubmit = ({ history, deploymentId }) => values => {
  return new Promise((resolve, reject) => {
    updateDeploymentService(
      { deploymentId, body: buildDeploymentBody(values) },
      () => {
        history.goBack();
        resolve();
      },
      e => {
        reject(e);
      },
    );
  });
};
